export default "__VITE_ASSET__SQZzfkSz__"